import React, { useEffect, useState } from 'react';

import { PageLoading } from '@/components/0-reusable-components/page-loading';
import Translation from '@/utils/common/translation';

interface Props {
  children: React.ReactElement;
}

const I18n = ({ children }: Props): React.ReactElement | null => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function initI18n(): Promise<void> {
      await Translation.initI18n();

      setIsLoading(false);
    }

    initI18n();
  }, []);

  return isLoading ? <PageLoading /> : children;
};

export default I18n;
